export const isValidSixDecimalNumber = (number) => {
  const numberToString = String(number)

  if (typeof number !== 'number' || Number.isNaN(number)) {
    return false
  }
  if (!numberToString.includes('.')) {
    // eslint-disable-next-line no-magic-numbers
    if(numberToString.length > 127) {
      return false
    }
  }
  if (numberToString.includes('.')) {
    // eslint-disable-next-line
      const splitedByDot = numberToString.split('.')
    // eslint-disable-next-line
      if (splitedByDot[1].length > 127) {
      return false
    }
    // eslint-disable-next-line
      if (splitedByDot[0].length > 1 && splitedByDot[0][0] === '0') {
      return false
    }
  }
  return true
}

export const noZeroAfterSixDecimal = (number) => {
  const result = number.split('.')
  // eslint-disable-next-line no-magic-numbers
  if (result.length > 1) {
    // eslint-disable-next-line no-magic-numbers
    return result[1].length < 127
  }

  return true
}

